<template>
  <div>
    <div class="row">
      <div class="col-8">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>HAVEN Lock</td>
            <td>
              <span v-if="featureG2SecureHavenLockConnected"><i class="fa fa-check-circle online" aria-hidden="true"></i> Connected</span>
              <span v-else><i class="fa fa-times-circle offline" aria-hidden="true"></i> Not Connected</span>
            </td>
            <td v-if="featureG2SecureHavenLockConnected">
              <a href="#" class="btn btn-light" @click="HavenLockDisconnect()"><i class="fas fa-ban fa-fw" aria-hidden="true"></i> Disconnect</a>
              <a href="#" class="btn btn-light" @click="HavenLockLoadLocks()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Load Locks</a>
            </td>
            <td v-else>
              <a href="#" class="btn btn-light" @click="HavenLockLogin()"><i class="fa fa-sync fa-fw" aria-hidden="true"></i> Connect</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
// This page shouldn't be visible if G2 Secure is not enabled.
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'havenLockOAuthLoginUrl',
      'featureG2SecureHavenLockConnected'
    ])
  },
  created () {
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE.G2_SECURE')
  },
  methods: {
    HavenLockLogin () {
      this.$store.dispatch('getHavenLockOAuthUrl').then(() => {
        window.location.href = this.havenLockOAuthLoginUrl
      })
    },
    HavenLockDisconnect () {
      if (prompt("If you disconnect, you will not be able to control or access any HAVEN locks.\n\nTo confirm that you want to disconnect from the HAVEN system,\n\nPlease type 'DISCONNECT' in the box below.\n\n").toLowerCase() === 'disconnect') {
        this.$store.dispatch('disconnectHavenLock')
      }
    },
    HavenLockLoadLocks () {
      this.$store.dispatch('loadLocksHavenLock')
    }
  }
}
</script>

<style scoped>

</style>
